export class BlockUIActions {
  static START = 'start';
  static STOP = 'stop';
  static UPDATE = 'update';
  static RESET = 'reset';
  static RESET_GLOBAL = 'reset_global';
  static UNSUBSCRIBE = 'unsubscribe';
}